/**
 * 表格配置（来自 CMS）里可能存着旧版蓝色，渲染前统一归一到品牌红。
 * 仅替换偏蓝/偏青的颜色，其它颜色（灰、绿等）保持原样。
 */
const BRAND_RED = '#C6202B'
const BRAND_RED_TINT = '#FDF3F4'

function parseColor(color) {
  if (!color) return null
  const value = String(color).trim().toLowerCase()

  if (value.startsWith('#')) {
    let hex = value.slice(1)
    if (hex.length === 3 || hex.length === 4) {
      hex = hex.slice(0, 3).split('').map(c => c + c).join('')
    }
    if (hex.length < 6) return null
    const r = parseInt(hex.slice(0, 2), 16)
    const g = parseInt(hex.slice(2, 4), 16)
    const b = parseInt(hex.slice(4, 6), 16)
    if ([r, g, b].some(Number.isNaN)) return null
    return { r, g, b }
  }

  if (value.startsWith('rgb')) {
    const nums = value.match(/-?\d+(\.\d+)?/g)
    if (!nums || nums.length < 3) return null
    return { r: +nums[0], g: +nums[1], b: +nums[2] }
  }

  if (value.startsWith('oklch')) {
    const nums = value.match(/-?\d+(\.\d+)?/g)
    if (!nums || nums.length < 3) return null
    const chroma = parseFloat(nums[1])
    const hue = parseFloat(nums[2])
    // 饱和度太低按中性灰处理，不动
    if (chroma < 0.08) return null
    return { hue }
  }

  return null
}

function isBlueish(color) {
  if (!color) return false
  if (color.hue !== undefined) {
    return color.hue >= 180 && color.hue <= 330
  }
  const { r, g, b } = color
  return b - r > 40 && b - g > 20
}

export function normalizeTableColor(color) {
  if (!color) return ''
  const parsed = parseColor(color)
  if (!parsed) return color
  return isBlueish(parsed) ? BRAND_RED : color
}

export function normalizeTableBgColor(color) {
  if (!color) return ''
  const parsed = parseColor(color)
  if (!parsed) return color
  return isBlueish(parsed) ? BRAND_RED_TINT : color
}
